import { StyledItemContent, StyledListBoxItem } from "./list-box-item.style";
import { MDSListBoxItemProps, MDSListBoxSlotName } from "./list-box-item.types";
import { getSlot, getUnslottedChildren } from "@/mds/utils/slots";

export const MDSListBoxItem = ({ children, ...props }: MDSListBoxItemProps) => {
  const unslottedChildren = getUnslottedChildren(children);
  const leftAddon = getSlot(children, MDSListBoxSlotName.LeftAddon);
  const rightAddon = getSlot(children, MDSListBoxSlotName.RightAddon);

  return (
    <StyledListBoxItem {...props}>
      {leftAddon}
      <StyledItemContent>{unslottedChildren}</StyledItemContent>
      {rightAddon}
    </StyledListBoxItem>
  );
};
